import { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { addNewLearner } from '../../actions/UserActions';

export default function useLearner() {
    const [ learner, setLearner ] = useState(null);
    const [ status, setStatus ] = useState({
        hasError: false,
        errorMessage: ''
    });
    const { learnerCreated, learnerResponse } = useSelector(state => ({
        learnerCreated: state.user.learnerCreated,
        learnerResponse: state.user.learnerResponse
    }));
    const dispatch = useDispatch();

    useEffect(() => {
        if (learnerCreated) {
            setLearner(learnerResponse);
        } else if (learnerResponse) {
            setStatus({
                hasError: true,
                errorMessage: 'Error creating new learner record'
            });
        }
    }, [learnerCreated, learnerResponse]);

    function createLearner(learnerRequest) {
        dispatch(addNewLearner(learnerRequest));
    }

    return { learner, setLearner, status, setStatus, learnerCreated,
        learnerResponse, createLearner };
}
